module.exports = __webpack_public_path__ + "static/img/anxunu09.0635733d.svg";